import {Injectable, Inject} from 'ng-metadata/core';
import {FullViewService} from '../fullView/fullView.service';


const _set = require('lodash/set');
const _find = require('lodash/find');
import {PrimoResponse} from '../../infra/dataStructures/PrimoResponses/doc.interfcae';
import {getVid} from '../../appConfig/appConfigForward';

@Injectable()
export class CitationTrailsService {

	constructor(@Inject('$http') private $http : ng.IHttpService,
				@Inject('restBaseURLs') private restBaseURLs) {
	}

	public updateCitationsList(docs:PrimoResponse.IDoc[]){
		if (!docs){
			return;
		}
		let frbrGroupIds = docs.filter( this.filterNonPcReocrd )
			.map( this.fetchFrbrGroupId );

		if(frbrGroupIds.length > 0){
			let payload = {
				frbrgroupids: frbrGroupIds,
                vid:getVid()
			};

			return this.$http.post(this.restBaseURLs.citationTrails, payload)
				.then( res => this.onSuccess(res, docs), this.onError );
		}
	}


	public fetchFrbrGroupId( doc:PrimoResponse.IDoc ) :string{
		if( !doc.pnx.facets.frbrgroupid || doc.pnx.facets.frbrgroupid.length === 0 ) {
			return null;
		}
		return doc.pnx.facets.frbrgroupid[0];
	}

	/////////////////////////////// Private ////////////////////////////////

	private onSuccess( res, docs:PrimoResponse.IDoc[] ){
		if ( res.error ){
			this.onError( res.error );
			return;
		}

		let results = res.data.data;

		docs.forEach( doc => this.updateDoc(doc, results));
        return docs;
	}

	private onError ( err ){
		console.error( err );
	}


	private updateDoc(doc:PrimoResponse.IDoc, results){
		let frbrGroup = this.fetchFrbrGroupId(doc);
		let matchingResult = _find(results, {frbrgroupid: frbrGroup});
		if( frbrGroup && matchingResult ){
			let ctData = {
				citing: matchingResult.citing,
				citedby: matchingResult.citedby
			};
			_set(doc,'extras.citationTrails', ctData);
		} else {
			_set(doc,'extras.citationTrails', {});
		}
	}

	////////////////////////// Helper methods /////////////////////////////

	private filterNonPcReocrd( doc:PrimoResponse.IDoc ) : boolean{
		return doc.context === 'PC' && doc.pnx.facets.frbrgroupid && doc.pnx.facets.frbrgroupid.length > 0;
	}
}


export default [];




// WEBPACK FOOTER //
// ./src/main/webapp/components/search/citationTrails/citationTrails.service.ts